import { useFetchOrganizationsByAliasQuery, useFetchOrganizationsByIdQuery } from "@/features/organizations/api/organizationsApi";
import useOrganizationTheme from "@/features/organizations/useOrganizationTheme";
import { Organization } from "@/types";
import { ThemeProvider } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useParams } from "react-router-dom";

type Props = {
  children: React.ReactNode;
};

type Params = {
  organizationId?: string;
  organizationAlias?: string;
};

const OrganizationThemeProvider = ({ children }: Props) => {
  const { organizationAlias, organizationId } = useParams<Params>();

  const aliasQuery = useFetchOrganizationsByAliasQuery(organizationAlias ?? skipToken, {
    skip: !organizationAlias,
  });

  const orgId = organizationId || aliasQuery?.data?.organizationId;

  const organizationQuery = useFetchOrganizationsByIdQuery(orgId ?? skipToken, {
    skip: !orgId,
  });

  const theme = useOrganizationTheme(organizationQuery?.data as Organization);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default OrganizationThemeProvider;
